import {
    LISTE_DISCOUNTS_ADD_LOADING,
    LISTE_DISCOUNTS_ADD_MODAL,
    LISTE_DISCOUNTS_ITEM_SETSTATUS_ACTIVER_MODAL, LISTE_DISCOUNTS_ITEM_SETSTATUS_DESACTIVER_MODAL,
    LISTE_DISCOUNTS_ITEM_SETSTATUS_LOADING,
    LISTE_DISCOUNTS_LOADING,
    LISTE_DISCOUNTS_SUCCESS
} from "../actions/types";

const initialState = {
    discounts: [],
    deliveries: [],
    itemPromoSetStatus: null,
    totalRows: 0,
    totalPages: 0,
    showAddModal: false,
    showItemSetStatusActiverModal: false,
    showItemSetStatusDesactiverModal: false,
    loading: false,
    loadingAdd: false,
    loadingItemStatus: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case LISTE_DISCOUNTS_SUCCESS:
            return {
                ...state,
                discounts: payload.discounts,
                totalRows: payload.totalRows,
                totalPages: payload.totalPages,
                loading: false
            };
        case LISTE_DISCOUNTS_LOADING:
            return {
                ...state,
                loading: payload.loading
            };
        case LISTE_DISCOUNTS_ADD_LOADING:
            return {
                ...state,
                loadingAdd: payload.loadingAdd,
            };

        case LISTE_DISCOUNTS_ADD_MODAL:
            return {
                ...state,
                showAddModal: !state.showAddModal
            };

        case LISTE_DISCOUNTS_ITEM_SETSTATUS_LOADING:
            return {
                ...state,
                loadingItemStatus: payload.loadingItemStatus
            };

        case LISTE_DISCOUNTS_ITEM_SETSTATUS_ACTIVER_MODAL:
            return {
                ...state,
                showItemSetStatusActiverModal: payload.showItemSetStatusActiverModal,
                itemPromoSetStatus: payload.itemPromoSetStatus,
            };

        case LISTE_DISCOUNTS_ITEM_SETSTATUS_DESACTIVER_MODAL:
            return {
                ...state,
                showItemSetStatusDesactiverModal: payload.showItemSetStatusDesactiverModal,
                itemPromoSetStatus: payload.itemPromoSetStatus,
            };

        default:
            return state;
    }
}
